import * as React from "react";

function SvgRecruiterMinLogo(props) {
  return <svg width={28} height={14} viewBox="0 0 28 14" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M4 0h23a1 1 0 011 1v9a4 4 0 01-4 4H1a1 1 0 01-1-1V4a4 4 0 014-4z" fill="#FF6400" fillRule="nonzero" /><text fontFamily="PingFangSC-Medium, PingFang SC" fontSize={10} fontWeight={400} fill="#FFF"><tspan x={2} y={10.5}>{"NEW"}</tspan></text></g></svg>;
}

export default SvgRecruiterMinLogo;